import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Upload } from 'app/model/upload';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from 'assets/url/urls';
import { LoginService } from '../login/login.service';
import { FileItem } from 'ng2-file-upload';
import { LoginConfirm } from 'app/model/user';

@Injectable()
export class UploadService {
  // Constante de la api de la base de datos
  // private REST_API_SERVER_JSON = 'https://json-portal-empleado.onrender.com';
  private REST_API_SERVER_JSON = urls.baseUrl;
  // private REST_API_SERVER_NODE = 'https://json-portal-empleado.onrender.com';
  private REST_API_SERVER_NODE = urls.baseUrl;
  private TENANT = urls.tenant;

  headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
    'X-TENANT-ID': this.TENANT
  }
  requestOptions = {
    headers: new HttpHeaders(this.headers),
  };


  headersData = {
    'Accept': 'application/json',
    'X-TENANT-ID': this.TENANT,
  };

  requestOptionsData = {
    headers: new HttpHeaders(this.headersData),
  };


  /**
   * Constructor
   * @param httpClient
   */
  constructor(private httpClient: HttpClient, private LoginService: LoginService) { }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  /**
   * Trae los usuarios de la base de datos
   * @returns Usuario
   */
  public getUpload() {
    return this.httpClient.get(this.REST_API_SERVER_JSON + '/uploads', this.requestOptions);
  }

  public extractTextFromPDF(file: File): Observable<Upload[]> {
    const formData = new FormData();
    formData.append('file', file);
    const fileRequestOptions = {
      headers: new HttpHeaders({ 'X-TENANT-ID': this.TENANT }),
    };
    return this.httpClient
      .post<Upload[]>(this.REST_API_SERVER_JSON + '/api/pdf/extractText', formData, fileRequestOptions)
      .pipe(
        catchError((error) => {
          console.error('Error al extraer texto de PDF:', error);
          throw error;
        })
      );
  }

  /**
   * Trae el usuario con la id seleccionada
   * @param id
   * @returns Usuario por id
   */
  public getUploadById(id) {
    return this.httpClient.get(this.REST_API_SERVER_JSON + '/uploads/' + id, this.requestOptions);
  }

  public getUploadedFileById(fileId: number, loginConfirm?: LoginConfirm): Observable<any> {
    const headers = new HttpHeaders({
      "X-TENANT-ID": this.TENANT
    })

    return this.httpClient.post(this.REST_API_SERVER_JSON + '/uploads/file/' + fileId, loginConfirm, {
      headers,
      responseType: "blob"
    })
  }

  public getFileContentBatchByIds(fileIds: number[], loginConfirm?: LoginConfirm): Observable<any> {
    const headers = new HttpHeaders({
      "X-TENANT-ID": this.TENANT
    })

    const params = new HttpParams().set('fileIds', fileIds.toString())

    return this.httpClient.post(this.REST_API_SERVER_JSON + '/uploads/file/batch', loginConfirm, {
      headers,
      params,
      responseType: "blob"
    })
  }

  /**
   * Crea el usuario en la base de datos
   * @param upload
   * @returns Usuario
   */
  public addUpload(upload: Upload) {
    return this.httpClient.post<Upload>(this.REST_API_SERVER_JSON + '/uploads', upload, this.requestOptions);
  }

  /**
   * Actualiza el usuario con la id seleccionada en la base de datos
   * @param id
   * @param upload
   * @returns Usuario actualizado
   */
  public updateUploadById(id, upload: Upload) {
    return this.httpClient.put(this.REST_API_SERVER_JSON + '/uploads/' + id, upload, this.requestOptions);
  }

  /**
   * Crea el usuario en la base de datos
   * @param upload
   * @returns Usuario
   */
  public createUpload(upload: Upload) {
    return this.httpClient.post(this.REST_API_SERVER_JSON + '/uploads', upload, this.requestOptions);
  }

  public createUploadToFolder(url: string, archivo: File) {
    const formData: FormData = new FormData();
    formData.append('file', archivo);
    return this.httpClient.post(url, formData, this.requestOptionsData);
  }


  public createMultiDniUpload(upload: Upload) {
    return this.httpClient.post(this.REST_API_SERVER_JSON + '/uploads', upload, this.requestOptions);
  }

  /**
   * Borra el usuario de la base de datos
   * @param id
   * @returns Usuario
   */
  public deleteUploadById(id) {
    return this.httpClient.delete(this.REST_API_SERVER_JSON + '/uploads/' + id, this.requestOptions);
  }

  public deleteUplaodApi(folder: string, subfolder: string, filename: string, ext: string) {
    return this.httpClient.delete(`${this.REST_API_SERVER_NODE}/${folder}/${subfolder}/${filename}.${ext}`, this.requestOptions);
  }


  public putUploadNoNominaApi(folder: string, subfolder: string, filename: string, ext: string, newFile: File) {
    const url = `${this.REST_API_SERVER_NODE}/${folder}/${subfolder}/${filename}.${ext}`;
    const formData = new FormData();
    formData.append('file', newFile);


    return this.httpClient.put(url, formData, this.requestOptions).pipe(
      catchError((error) => {
        console.error('Error en la solicitud PUT:', error);
        return throwError(error);
      })
    );
  }



  /**
   * File Profile Picture
   */
  public uploadProfilePicture(formaData: FormData, id) {
    return this.httpClient.post(this.REST_API_SERVER_JSON + '/uploads/' + id, this.requestOptions);
  }
}
